// extracted by mini-css-extract-plugin
export var copyableItem = "_d-0";
export var underlined = "_d-1";